module.exports = __webpack_public_path__ + "img/round7.bdf0c3e1.png";